import { visserApi } from "./visserApi";
const createDeliveryNote = async (createDebtorSpecification) => {
    return await visserApi.post(`DeliveryNote/Create`, createDebtorSpecification);
};
const updateDeliveryNote = async (updateDebtorSpecification) => {
    return await visserApi.put(`DeliveryNote/Update`, updateDebtorSpecification);
};
const getDeliveryNotebyId = async (id) => {
    return await visserApi.get(`DeliveryNote/GetById/${id}`);
};
const getAllDeliveryNotes = async (id) => {
    return await visserApi.get(`DeliveryNote/GetAll/${id}`);
};
const DeliveryNoteApi = {
    createDeliveryNote,
    getDeliveryNotebyId,
    updateDeliveryNote,
    getAllDeliveryNotes
};
export default DeliveryNoteApi;
